import * as React from "react";
import type { CertificationTraining } from "../../lib/api/certifications";
import { CoursePageView } from "../certification/CoursePageView";
import * as styles from "./ModuleDetailPage.css";

/** Design canvas for the certification portal course page preview. */
export const COURSE_PAGE_PREVIEW_WIDTH = 1300;
export const COURSE_PAGE_PREVIEW_HEIGHT = 980;

export function CoursePagePreview({
  title,
  heroImageUrl,
  trainings,
}: {
  title: string;
  heroImageUrl?: string | null;
  trainings: CertificationTraining[];
}) {
  const frameRef = React.useRef<HTMLDivElement>(null);
  const [scale, setScale] = React.useState(0);

  React.useLayoutEffect(() => {
    const el = frameRef.current;
    if (!el) return;

    const update = (width: number) => {
      setScale(width > 0 ? width / COURSE_PAGE_PREVIEW_WIDTH : 0);
    };

    update(el.getBoundingClientRect().width);

    const ro = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;
      update(entry.contentRect.width);
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div
      ref={frameRef}
      className={styles.coursePagePreviewFrame}
      style={{ aspectRatio: `${COURSE_PAGE_PREVIEW_WIDTH} / ${COURSE_PAGE_PREVIEW_HEIGHT}` }}
    >
      <div
        className={styles.coursePagePreviewScaled}
        style={{
          transform: `scale(${scale})`,
          visibility: scale > 0 ? "visible" : "hidden",
        }}
      >
        <CoursePageView
          title={title}
          heroImageUrl={heroImageUrl}
          trainings={trainings}
          interactive={false}
          preview
        />
      </div>
    </div>
  );
}
